import Vue from 'vue'
import VueRouter from 'vue-router'
import Games from '@/views/Games'
import CreateWheel from '@/views/CreateWheel'
import LoginView from '@/views/LoginView'
import AssetLibrary from '@/views/AssetLibrary'
import GameRules from '@/views/GameRules'
import RulePreview from '@/views/RulePreview'
import ResetPassword from '@/views/ResetPassword'
import VerifyCode from '@/views/VerifyCode'
import ChangePassword from '@/views/ChangePassword'
import TenantSelection from '@/views/TenantSelection'
import Admin from '@/views/Admin'

import { isAuthenticated } from "@/auth"
import store from "@/store"

Vue.use(VueRouter)

const routes = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: {
      hideNavigation: true
    }
  },
  {
    path: "/resetpassword",
    name: "resetPassword",
    component: ResetPassword,
    meta: {
      hideNavigation: true
    }
  },
  {
    path: "/verifycode",
    name: "verifyCode",
    component: VerifyCode,
    meta: {
      hideNavigation: true
    }
  },
  {
    path: "/changepassword",
    name: "changePassword",
    component: ChangePassword,
    meta: {
      hideNavigation: true
    }
  },
  {
    path: "/tenant-selection",
    name: "tenantSelection",
    component: TenantSelection,
    meta: {
      requiresAuth: true,
      adminOnly: true,
      hideNavigation: true
    }
  },
  {
    path: '/',
    name: 'games',
    component: Games,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/game/:id',
    name: 'game',
    component: CreateWheel,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/assets',
    name: 'assets',
    component: AssetLibrary,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/gamerules',
    name: 'gameRules',
    component: GameRules,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/rulepreview',
    name: 'rulePreview',
    component: RulePreview,
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '*',
    redirect: '/'
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Check if the user is authenticated
    if (!isAuthenticated()) {
      next({ name: "login" });
    } else {
      // Check if user is admin and needs tenant selection
      const user = store.getters.getUser;
      const tenant = store.getters.getTenant;
      
      if (user?.name === 'admin' && !tenant) {
        // Admin user without tenant selection
        if (to.name !== 'tenantSelection') {
          next({ name: 'tenantSelection' });
        } else {
          next();
        }
      } else if (to.matched.some((record) => record.meta.adminOnly)) {
        // Admin only route
        if (user?.name === 'admin') {
          next();
        } else {
          next({ name: 'games' });
        }
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

export default router
